"use client";

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function IndustriesSection() {
  return (
    <section className="container py-24 px-4 mx-auto">
      {/* هدر بخش */}
      <div className="mb-12 flex flex-col items-center text-center">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-white">
          Beyond Limits, <span className="text-primary">Across Industries</span>
        </h2>
        <p className="mt-4 max-w-[700px] text-muted-foreground">
          We don't just build software; we engineer intelligence for the most critical sectors.
        </p>
      </div>

      {/* شروع Bento Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[minmax(180px,auto)]">
        
        {/* کارت ۱: نفت و گاز (بزرگ - ۲ ستون) */}
        <Card className="md:col-span-2 bg-secondary/50 border-white/5 hover:border-primary/50 transition-colors group">
          <CardHeader>
            <div className="h-20 w-20 mb-2">
              <DotLottieReact
                src="/animations/oil.json"
                loop
                autoplay
              />
            </div>
            <CardTitle className="text-xl text-white">Oil, Gas & Petrochemical</CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-base text-slate-300">
              Predictive maintenance for rigs, pipeline monitoring using computer vision, and energy consumption optimization algorithms.
            </CardDescription>
          </CardContent>
        </Card>

        {/* کارت ۲: فین‌تک (کوچک - ۱ ستون) */}
        <Card className="bg-secondary/50 border-white/5 hover:border-primary/50 transition-colors group">
          <CardHeader>
            <div className="h-20 w-20 mb-2">
              <DotLottieReact
                src="/animations/finance.json"
                loop
                autoplay
              />
            </div>
            <CardTitle className="text-xl text-white">Fintech & Banking</CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-slate-300">
              Real-time fraud detection, algorithmic trading, and personalized financial assistants.
            </CardDescription>
          </CardContent>
        </Card>

        {/* کارت ۳: لجستیک (کوچک - ۱ ستون) */}
        <Card className="bg-secondary/50 border-white/5 hover:border-primary/50 transition-colors group">
          <CardHeader>
            <div className="h-20 w-20 mb-2">
              <DotLottieReact
                src="/animations/truck.json"
                loop
                autoplay
              />
            </div>
            <CardTitle className="text-xl text-white">Supply Chain</CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-slate-300">
              Demand forecasting, smart routing, and warehouse automation.
            </CardDescription>
          </CardContent>
        </Card>

        {/* کارت ۴: تولید هوشمند (بزرگ - ۲ ستون) */}
        <Card className="md:col-span-2 bg-secondary/50 border-white/5 hover:border-primary/50 transition-colors group">
          <CardHeader>
            <div className="h-20 w-20 mb-2">
              <DotLottieReact
                src="/animations/manufacture.json"
                loop
                autoplay
              />
            </div>
            <CardTitle className="text-xl text-white">Smart Manufacturing</CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-base text-slate-300">
              IoT integration, quality control with AI vision, and autonomous production lines using digital twins.
            </CardDescription>
          </CardContent>
        </Card>

      </div>
    </section>
  );
}